import TutorialsSection from './tutorialsSection'

export default TutorialsSection
